import React from 'react';

import Inquisitive2024 from 'views/Inquisitive2024';
const SchoolProgrampage = () => {
  return <Inquisitive2024 />;
};

export default SchoolProgrampage;